import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modifier", "imagesInput", "imagesLabel"];

  connect() {
    this.form = this.element;
    this.textArea = this.element.querySelector("textarea");
    this.defaultImagesLabel = this.hasImagesLabelTarget ? this.imagesLabelTarget.textContent : null;
    this.listener = this.textArea.addEventListener("keydown", this.keydown);
  }

  disconnect() {
    this.textArea.removeEventListener("keydown", this.listener);
  }

  keydown(event) {
    if (!event.ctrlKey) {
      return;
    }

    if (event.key === "Enter") {
      this.form.requestSubmit();
    }
  }

  imagesChanged() {
    if (!this.hasImagesLabelTarget || !this.hasImagesInputTarget) return;

    const count = this.imagesInputTarget.files?.length || 0;
    if (count === 0) {
      this.imagesLabelTarget.textContent = this.defaultImagesLabel;
    } else if (count === 1) {
      this.imagesLabelTarget.textContent = "1 image selected";
    } else {
      this.imagesLabelTarget.textContent = `${count} images selected`;
    }
  }
}
